import contains from "ramda/src/contains";

export function success(callback) {
  return (action) => {
    if (!/.*(_FAIL)/.test(action.type)) {
      callback && callback(action);
    }
    return action;
  };
}

export const dispatchHandler = (callback, callbackFail) => {
  return (action) => {
    if (!/.*(_FAIL)/.test(action.type)) {
      callback && callback(action);
    } else {
      callbackFail && callbackFail(action);
    }
    return action;
  };
};

function normalizeTargetName(mixed) {
  const mapping = {
    ALGARCRM: "ALGAR CRM",
    ALGAR_CRM: "ALGAR CRM",
    CONTROLPLUS: "CONTROL PLUS",
    CONTROL_PLUS: "CONTROL PLUS",
  };

  return mapping[mixed] || mixed;
}

function getTargetAttrName({ targetSystem }) {
  const attrNames = ["CONTROL PLUS", "SIEBEL"];
  const targetName = normalizeTargetName(targetSystem);

  return contains(targetName, attrNames) ? "targetSystem" : "targetCrm";
}

export function normalizeTargetSystem(obj) {
  const targetAttrName = getTargetAttrName(obj);
  const targetSystem = obj[targetAttrName];

  return normalizeTargetName(targetSystem);
}



// WEBPACK FOOTER //
// ./src/services/utils/action.js